import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MenuComponent } from '../../menu/menu/menu.component';

@Component({
  selector: 'bpw-not-found',
  standalone: true,
  imports: [MenuComponent],
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
})
export class NotFoundComponent {
  private readonly _router = inject(Router);

  navigateToDashboard() {
    this._router.navigateByUrl('dashboard');
  }
}
